import { deleteWalletBalanceMonitor } from "src/api/merchant";
import DeleteDialogProvider, {
  useDialogProviderContext,
} from "src/features/DialogProvider";
import { usePageConfigProviderContext } from "src/features/PageConfigProvider";
import { useAlerting, useTranslation } from "src/hooks";
import { GetListRes } from "src/views/WalletManagement/WalletBalanceMonitor/types/GetListRes";
import {
  TableColumnKey,
  TableRow,
} from "src/views/WalletManagement/WalletBalanceMonitor/types/Table";

function DeleteDialog({
  rowData,
}: {
  rowData: TableRow & { rawData: GetListRes };
}) {
  const { translatePrefix, refreshData } = usePageConfigProviderContext();
  const { t } = useTranslation(translatePrefix);
  const { alerting } = useAlerting();
  const { setIsOpen } = useDialogProviderContext();

  const onConfirm = async () => {
    const res = await deleteWalletBalanceMonitor({
      assetName: rowData[TableColumnKey.Currency],
      walletAddress: rowData[TableColumnKey.WalletAddress],
      chainType: rowData.rawData.chain_type,
      chainId: rowData.rawData.chain_id,
    });

    if (!res) {
      return;
    }

    alerting("success", t("delete_wallet_balance_monitor_success"));
    refreshData();
    setIsOpen(false);
  };

  return (
    <DeleteDialogProvider.DialogInOne
      title={t("delete_dialog_title")}
      content={null}
      onConfirm={onConfirm}
    />
  );
}

export default DeleteDialog;
